<template>
  <div id="content-bg">
    <div class="card-first">
      <p class="title-p1">【重要须知】</p>
      <p class="card-cont1">“绿仔管家（用户版）”应用软件（以下简称“绿仔”）是为用户提供“一站式”社区服务的平台。“绿仔管家（用户版）”的所有权和运作权归第一物业服务(北京)有限公司（以下简称“第一服务”）。</p>
      <p class="card-cont1">用户务必仔细阅读、充分理解《绿仔管家（用户版）服务条款及隐私协议》（下称“本协议”）的内容。未成年人应在法定监护人陪同下阅读。除非用户接受本协议所有条款，否则请勿下载、安装或使用本软件及其相关服务。本协议的修改权归第一服务。用户应当随时关注本服务条款的修改，并决定是否继续使用“绿仔管家（用户版）”提供的各项服务。用户的下载、安装、使用、账号获取和登录等行为将视为对当时的服务条款及隐私协议的同意和承诺遵守。</p>
      <p class="card-cont1">“第一服务”保留因业务发展需要，单方面对本服务的全部或者部分服务内容在任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销“绿仔管家（用户版）”服务的权力，用户需承担此风险。</p>
    </div>
    <div class="line"></div>
    <div class="card">
      <p class="title-p1">【协议的范围】</p>
      <p class="card-cont1">本协议是用户与“第一服务”之间关于下载、安装、使用、复制本软件，以及使用“第一服务”相关服务所订立的协议。</p>
      <p class="card-cont1">本协议、本协议附件和与本软件使用的第三方软件或技术相关的协议或其他文件等，共同构成了本软件及服务的完整协议。</p>
    </div>
    <div class="line"></div>
    <div class="card-last">
      <p class="title-p1">【知识产权声明】</p>
      <p class="card-cont1">1. “绿仔管家（用户版）”的一切版权、商标权、专利权、商业秘密等知识产权，以及与软件相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料或电子文档等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护，除涉及第三方授权的软件或技术外，“第一服务”享有上述知识产权。</p>
      <p class="card-cont1">2. 未经“第一服务”书面同意，用户不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何第三方实施、利用、转让上述知识产权，“第一服务”保留追究上述未经许可行为的权利。</p>
      <p class="card-cont1">3. 第三方软件和技术</p>
      <p class="card-cont1">• 本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
      <p class="card-cont1">• 本软件如果使用了第三方的软件或技术，“第一服务”将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，用户应当遵守这些要求。</p>
      <p class="card-cont1">• 如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，“第一服务”不承担任何责任。“第一服务”不对第三方软件或技术提供客服支持，若用户需要获取支持，请与第三方联系。</p>
    </div>
    <div class="line"></div>
    <div class="card-last">
      <p class="title-p1">【服务条款】</p>
      <p class="card-cont1">1.关于账户</p>
      <p class="card-cont1">您无需用户账户即可浏览“绿仔管家（用户版）”的部分内容。如果您想使用更多功能，您必须注册并且于注册页面上提供相关的个人信息。您必须承诺和保证：</p>
      <p class="card-cont1">• 您提交的所有注册信息必须真实准确；</p>
      <p class="card-cont1">• 您使用“绿仔管家（用户版）”的行为必须合法。</p>
      <p class="card-cont1">• 您保证在遵守法律法规和确保安全的前提下使用本软件。</p>
      <p class="card-cont1">您可以按照“绿仔管家（用户版）”的说明随时终止使用您的账户。“绿仔管家（用户版）”将会依据本协议第6条的规定保留或终止您的账户。您必须承诺对您的登录信息保密、不被其他人获取并使用并且对您在“绿仔管家（用户版）”账户下的所有行为负责。您必须将任何有可能触犯法律的，未授权使用或怀疑为未授权使用的行为在第一时间通知我们。“绿仔管家（用户版）”不对您因未能遵守上述要求而造成的损失承担法律责任。</p>
      <p class="card-cont1">2.终端用户协议</p>
      <p class="card-cont1">2.1 许可</p>
      <p class="card-cont1">依据本协议规定，“绿仔管家（用户版）”将授予您以下不可转让的、非排他的许可：</p>
      <p class="card-cont1">• 使用本软件的权利；</p>
      <p class="card-cont1">• 在您所有的移动通信设备上下载、安装、使用“绿仔管家（用户版）”的权利。</p>
      <p class="card-cont1">2.2 限制性条款</p>
      <p class="card-cont1">本协议对您的授权将受到以下限制：</p>
      <p class="card-cont1">• 您不得对“绿仔管家（用户版）”进行任何形式的许可、出售、租赁、转让、发行或做其他商业用途；</p>
      <p class="card-cont1">• 除非法律禁止此类限制，否则您不得对“绿仔管家（用户版）”的任何部分或衍生产品进行修改、翻译、改编、合并、利用、分解或反向编译等；</p>
      <p class="card-cont1">• 您不得以创建相同或竞争服务为目的使用“绿仔管家（用户版）”；</p>
      <p class="card-cont1">• 除非法律明文规定，否则您不得对“绿仔管家（用户版）”的任何部分以任何形式或方法进行复制、发行、再版、下载、显示或张贴等；</p>
      <p class="card-cont1">• 您不得删除或破坏包含在“绿仔管家（用户版）”中的任何版权声明或其他所有权标记。</p>
      <p class="card-cont1">2.3 权利归属</p>
      <p class="card-cont1">• “绿仔管家（用户版）”运营方许可您下载和使用“绿仔管家（用户版）”；</p>
      <p class="card-cont1">• “绿仔管家（用户版）”运营方（及其“授权人”，如有）拥有“绿仔管家（用户版）”的包括相关的知识产权在内的所有权利、所有权和利益，但不包括您的用户内容。</p>
      <p class="card-cont1">2.4 费用</p>
      <p class="card-cont1">• 您必须自行准备上网设备，包括并不限于手机、平板、电脑或者其他上网终端。</p>
      <p class="card-cont1">• 您必须自行负担个人上网或第三方（包括但不限于电信或移动通讯提供商）收取的通讯费、信息费等相关费用。如涉及电信增值服务，我们建议您与增值服务提供商确认相关费用问题。</p>
      <p class="card-cont1">2.5 任何“绿仔管家（用户版）”的未来版本、更新或者其他变更将受到本协议约束</p>
      <p class="card-cont1">3.用户内容</p>
      <p class="card-cont1">3.1 用户内容</p>
      <p class="card-cont1">• 用户内容是指该用户下载、发布或以其他方式使用“绿仔管家（用户版）”时产生的所有内容（例如：您的信息、文字、图片、音频、视频或其他内容）。</p>
      <p class="card-cont1">• 您是您的用户内容唯一的责任人，您将承担因您的用户内容披露而导致的您或任何第三方被识别的风险。</p>
      <p class="card-cont1">• 您已同意您的用户内容受到第4条的限制。</p>
      <p class="card-cont1">3.2 许可</p>
      <p class="card-cont1">您通过上传、发行或其他方式使用“绿仔管家（用户版）”的用户内容时，即视为自动授权且承诺和保证您有权授权给我们不可撤销的、非独家的、免版税的且足额缴纳的全球许可，用以：</p>
      <p class="card-cont1">• 仅为向您提供“绿仔管家（用户版）”服务或改进“绿仔管家（用户版）”之目的，复制、发行、公开展示和表演、制作衍生作品、将其纳入其他作品或以其他方式使用您的用户账户（排除您的个人信息）；并授予上述事项的转让许可；</p>
      <p class="card-cont1">• 仅为向目标接收者提供个人信息之目的，复制、发行您的用户内容中的私人信息；</p>
      <p class="card-cont1">• 您同意不可撤销的、放弃的（并会导致被放弃）关于您用户内容的道德权利和归属的声明。</p>
      <p class="card-cont1">3.3 反馈</p>
      <p class="card-cont1">• 您对“绿仔管家（用户版）”提出的建议（或称“反馈”），即视为您向“绿仔管家（用户版）”运营方转让“反馈”的全部权利并同意“绿仔管家（用户版）”运营方有权利以任何合理方式使用此反馈及其相关信息。我们将视此类反馈信息为非保密且非专有；</p>
      <p class="card-cont1">• 您已同意您不会向“绿仔管家（用户版）”运营方提供任何您视为保密和专有的信息。</p>
      <p class="card-cont1">3.4 我们将保留基于我们的判断检查用户内容的权利（而非义务）。无论通知与否，我们有权在任何时间以任何理由删除和移动您的用户内容。依据第5条规定，我们有权保留或终止您的账户</p>
      <p class="card-cont1">4.权利限制</p>
      <p class="card-cont1">4.1 在使用“绿仔管家（用户版）”中，您将承担因下述行为所造成的风险而产生的全部法律责任。</p>
      <p class="card-cont1">• 破坏宪法所确定的基本原则的；</p>
      <p class="card-cont1">• 危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；</p>
      <p class="card-cont1">• 损害国家荣誉和利益的；</p>
      <p class="card-cont1">• 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p class="card-cont1">• 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p class="card-cont1">• 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p class="card-cont1">• 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p class="card-cont1">• 侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p class="card-cont1">• 含有法律、行政法规禁止的其他内容的。</p>
      <p class="card-cont1">4.2 您已同意不在“绿仔管家（用户版）”从事下列行为：</p>
      <p class="card-cont1">• 上传或发布电脑病毒、蠕虫、恶意代码、故意破坏或改变计算机系统或数据的软件；</p>
      <p class="card-cont1">• 未授权的情况下，收集其他用户的信息或数据，例如电子邮箱地址等；</p>
      <p class="card-cont1">• 禁用“绿仔管家（用户版）”的网络连接，给“绿仔管家（用户版）”造成过度的负担或以其他方式干扰或损害网站服务器和网络链接；</p>
      <p class="card-cont1">• 在未授权的情况下，尝试访问“绿仔管家（用户版）”或服务器；</p>
      <p class="card-cont1">• 干扰、破坏“绿仔管家（用户版）”其他用户的使用。</p>
      <p class="card-cont1">5.购买须知</p>
      <p class="card-cont1">当您购买的商品到达指定地点/物业后，快递人员/物业会及时电话通知您取货，请在接到通知后24小时内领取。而由于您个人原因无法及时领取货物，造成商品破损、腐败、过期等非人为质量问题，将由您自行负责。</p>
      <p class="card-cont1">6.修改、终止</p>
      <p class="card-cont1">6.1 修改</p>
      <p class="card-cont1">• 本协议容许变更。如果本协议有任何实质性变更，我们将通过本软件的公告来通知您。变更通知之后，继续使用“绿仔管家（用户版）”则视为您已知晓此类变更并同意受条款其约束。</p>
      <p class="card-cont1">• “绿仔管家（用户版）”运营方保留在任何时候无需通知而修改、保留或关闭“绿仔管家（用户版）”或任何服务之权利。</p>
      <p class="card-cont1">• 您已同意“绿仔管家（用户版）”运营方无需因修改、保留或关闭“绿仔管家（用户版）”或其他服务的行为对您或第三方承担责任。</p>
      <p class="card-cont1">6.2 终止</p>
      <p class="card-cont1">• 本协议自您接受之日起生效，在您使用“绿仔管家（用户版）”的过程中持续有效，直至依据本协议终止；</p>
      <p class="card-cont1">• 尽管有上述规定，如果您使用“绿仔管家（用户版）”的时间早于您接受本协议的时间，您在此知晓并同意本协议于您第一次使用“绿仔管家（用户版）”时生效，除非依据本协议提前终止；</p>
      <p class="card-cont1">• 我们可能会：（1）依据法律的规定，保留您使用“绿仔管家（用户版）”账户的权利；（2）无论是否通知，我们将在任何时间以任何原因终止本协议，包括出于善意的相信您违反了我们可接受使用政策或本协议的其他规定；</p>
      <p class="card-cont1">• 不受前款规定所限，如果用户侵犯第三人的版权且“绿仔管家（用户版）”运营方接到版权所有人或版权所有人的合法代理人的通知后，“绿仔管家（用户版）”运营方保留终止本协议的权利；</p>
      <p class="card-cont1">• 一旦本协议终止，您的账户和使用“绿仔管家（用户版）”的权利即告终止。“绿仔管家（用户版）”运营方不因终止本协议对您承担任何责任，包括终止您的用户账户和删除您的用户内容。</p>
      <p class="card-cont1">7. 第三方</p>
      <p class="card-cont1">7.1 您已知晓或同意“绿仔管家（用户版）”的部分商品或服务是由第三方（简称商家）提供的，您通过“绿仔管家（用户版）”购买商家的商品或服务后，由商家对商品或服务质量提供保证、并提供售后服务。“绿仔管家（用户版）”仅提供商家与您之间进行交易的平台。</p>
      <p class="card-cont1">7.2 “绿仔管家（用户版）”上商家提供的商品和服务，均以商家自身名义进行商品信息上传、展示、商品销售、发票开具、售后服务提供等；商家销售及服务出现争议、纠纷、国家机关机构调查时，由商家以销售者身份处理。“绿仔管家（用户版）”及运营方不参与商家商品和服务的经营。除根据相关法律法规规定外，“绿仔管家（用户版）”及运营方不直接介入商家与其他人（含消费者）间的争议和纠纷。如商家有违反法律法规及本协议约定行为导致任何法律后果的发生，商家将以自己的名义独立承担所有相应的法律责任。</p>
      <p class="card-cont1">7.3 和“绿仔管家（用户版）”合作的企业负责所管理社区内消费者在购买“绿仔管家（用户版）”上的商品和服务后的货品代收、代送（根据消费者要求）、问题沟通协调及处理。商品和服务质量本身导致的任何法律后果与“绿仔管家（用户版）”及运营方无关。</p>
      <p class="card-cont1">7.4 您已知晓本协议是在您与“绿仔管家（用户版）”运营方之间签订，而非您与第三方之间签订。“绿仔管家（用户版）”运营方是基于“绿仔管家（用户版）”所产生的内容、维护、支持服务、保证和由此产生的诉讼等事项的唯一责任人。您已同意遵守且授权给“绿仔管家（用户版）”限制您有条件的使用“绿仔管家（用户版）”的服务。</p>
      <p class="card-cont1">7.5 第三方网站和广告</p>
      <p class="card-cont1">• “绿仔管家（用户版）”可能包含了第三方网站和广告。“绿仔管家（用户版）”运营方不控制且不对第三方的网站和广告负责。</p>
      <p class="card-cont1">• “绿仔管家（用户版）”运营方仅为您使用方便之目的或为承诺和保证第三方之需要而提供此类网站和广告。</p>
      <p class="card-cont1">• 您需对您使用第三方网站和广告产生的风险承担法律责任。</p>
      <p class="card-cont1">• 当您访问第三方网站和广告时，适用第三方的条款和政策。</p>
      <p class="card-cont1">7.6 其他用户</p>
      <p class="card-cont1">• “绿仔管家（用户版）”可能包含其他用户提供的用户内容。“绿仔管家（用户版）”不控制且不对用户内容承担法律责任。“绿仔管家（用户版）”没有检查、监控、审批、核准、承诺并保证用户内容的义务。您必须因使用用户内容和与其他用户互动产生的风险承担法律责任。</p>
      <p class="card-cont1">• 您与其他用户的互动仅属于于您与其他用户之间的行为，“绿仔管家（用户版）”对此类行为不承担任何法律责任。您已同意“绿仔管家（用户版）”对此类互动行为的结果不承担法律责任。</p>
      <p class="card-cont1">8.赔偿</p>
      <p class="card-cont1">8.1 您已同意无害的使用“绿仔管家（用户版）”，避免“绿仔管家（用户版）”运营方因下述行为或相关行为遭受来自第三方的任何投诉、诉讼、损失、损害、责任、成本和费用（包括律师费）：</p>
      <p class="card-cont1">• 您使用“绿仔管家（用户版）”的行为；</p>
      <p class="card-cont1">• 您的用户内容；</p>
      <p class="card-cont1">• 您违反本协议的行为。</p>
      <p class="card-cont1">8.2 “绿仔管家（用户版）”运营方保留专属抗辩权和请求赔偿的权利。</p>
      <p class="card-cont1">8.3 您已同意，除非获得“绿仔管家（用户版）”运营方书面同意，您不得在您与“绿仔管家（用户版）”运营方共同对第三方提起的诉讼中单方和解。</p>
      <p class="card-cont1">8.4 “绿仔管家（用户版）”运营方将尽合理努力将此类诉讼、诉讼行为或进程通知您。</p>
      <p class="card-cont1">8.5 在任何情况下，“绿仔管家（用户版）”都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。访问、使用“绿仔管家（用户版）”所产生的损坏计算机系统或移动通讯设备数据库的风险将由您个人承担。</p>
      <p class="card-cont1">9.免责声明</p>
      <p class="card-cont1">如发生下述情形，“绿仔管家（用户版）”及其运营方不承担任何法律责任：</p>
      <p class="card-cont1">• 由不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，“绿仔管家（用户版）”将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户造成的损失“第一服务法律允许的范围内免责。</p>
      <p class="card-cont1">• 依据法律规定或相关政府部门的要求提供您的个人信息；</p>
      <p class="card-cont1">• 由于您的使用不当而导致任何个人信息的泄露；</p>
      <p class="card-cont1">• 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的情形；</p>
      <p class="card-cont1">• 用户因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；</p>
      <p class="card-cont1">• 由于您在违反法律法规的前提下使用本软件而造成的事故及其由此产生的任何损失。</p>
      <p class="card-cont1">• 使用“绿仔管家（用户版）”可能存在的来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息而招致的风险；</p>
      <p class="card-cont1">• 用户之间通过 “绿仔管家（用户版）”与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</p>
      <p class="card-cont1">• “绿仔管家（用户版）”明文声明，不以明示或默示及以任何形式对“绿仔管家（用户版）”及其合作公司服务之及时性、安全性、准确性做出担保。</p>
      <p class="card-cont1">10.隐私政策</p>
      <p class="card-cont1">请查阅本协议的隐私协议部分</p>
      <p class="card-cont1">11. 通知</p>
      <p class="card-cont1">“绿仔管家（用户版）”发布的公告通知毫无疑问构成有效通知。</p>
      <p class="card-cont1">12. 适用法律</p>
      <p class="card-cont1">12.1 本协议适用中华人民共和国法律。</p>
      <p class="card-cont1">12.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向”绿仔管家（用户版）”运营方所在地的法院提起诉讼。</p>
      <p class="card-cont1">13. 独立性</p>
      <p class="card-cont1">本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。</p>
      <p class="card-cont1">14. 完整性</p>
      <p class="card-cont1">14.1 本协议（包括隐私政策）是您和“绿仔管家（用户版）”之间关于“绿仔管家（用户版）”相关事项的最终的、完整的、排他的协议，且取代和合并之前当事人关于此类事项（包括之前的最终用户许可、服务条款和隐私政策）的讨论和协议。</p>
      <p class="card-cont1">14.2 每部分的题目只为阅读之便而无任何法律或合同义务。</p>
      <p class="card-cont1">14.3 除非“绿仔管家（用户版）”运营方书面同意，您不得转让本协议所规定的权利义务。任何违反上述规定企图转让的行为均无效。</p>
      <p class="card-cont1">15. 联系我们</p>
      <p class="card-cont1">地址：北京市东城区东直门外香河园路1号当代节能置业办公楼三层</p>
      <p class="card-cont1">邮编：100028</p>
      <p class="card-cont1">电话：010-84407072</p>
      <p class="card-cont1">电子邮箱：lanlvxiangjian@firstcare.com.cn</p>
    </div>
    <div class="line"></div>
    <div class="card-last">
      <p class="title-p1">【隐私协议】</p>
      <p class="card-cont1">1.个人信息的收集</p>
      <p class="card-cont1">1.1 个人信息 </p>
      <p class="card-cont1">我们使用、保存、使用和披露个人信息是为了通过创建账户、识别用户、回应查询和邮件等方式来为您提供服务。“绿仔管家（用户版）”会向您提供关于社区生活相关的服务、发送资讯、调查、优惠和促销信息以及其他宣传材料以为您提供更好的服务。</p>
      <p class="card-cont1">1.2 为实现服务目的而收集 </p>
      <p class="card-cont1">用更多功能，您必须注册并且于注册页面上提供相关的个人信息。您必须承诺和保证：</p>
      <p class="card-cont1">• 为实现“绿仔管家（用户版）”之服务目的，“绿仔管家（用户版）”会通过技术手段收集您的个人信息，通过技术手段所收集的个人信息仅限于您的电话号码、手机通讯录等使用“绿仔管家（用户版）”所必需的信息。</p>
      <p class="card-cont1">• “绿仔管家（用户版）”支持多类操作系统的使用：在您通过各种手机操作系统使用“绿仔管家（用户版）”的过程中，“绿仔管家（用户版）”所收集的信息仅限于您同意使用“绿仔管家（用户版）”基本服务所必需的信息。</p>
      <p class="card-cont1">• 经过您的允许后，“绿仔管家（用户版）”将可能分析您的手机通讯录，来帮助您寻找已经在使用“绿仔管家（用户版）”的朋友。“绿仔管家（用户版）”通过高强度、不可逆的加密算法（将收集到的号码加密成为一系列不可解密的字符串）来加密您的通讯录信息，并依据改加密后的信息进行好友匹配的操作</p>
      <p class="card-cont1">1.3 用户提供</p>
      <p class="card-cont1">• 如果您需要使用更多功能，例如将“绿仔管家（用户版）”的内容分享到微博、微信等其它第三方网站，您需要完善您的个人信息，如填写您的邮箱、性别、所在地、公司、生日等。</p>
      <p class="card-cont1">• 您提供的信息，“绿仔管家（用户版）”将最大限度尽合理之商业义务进行保密。经过您的同意，“绿仔管家（用户版）”将会向您提供电子商务、生活服务、资讯、版本升级等服务。</p>
      <p class="card-cont1">1.4 “绿仔管家（用户版）”软件提供用户之间发送信息和其他内容的功能如果您将信息或其他内容发送给另一个用户，“绿仔管家（用户版）”服务器将会为您保存此信息/内容，并将此信息/内容发送给该用户。</p>
      <p class="card-cont1">1.5 您提供信息的其他方式</p>
      <p class="card-cont1">我们将采用其他方式（例如：电子邮件、信息下载、购买产品或服务、用户支持、反馈以及调查表）来收集您的个人信息。如果您将个人信息填写在其他开放的平台上，其他用户可能会获知您的信息。</p>
      <p class="card-cont1">1.6 您的其他信息 </p>
      <p class="card-cont1">为了便于您使用“绿仔管家（用户版）”软件，我们的服务器将会收集关于您的移动通讯设备的信息，例如型号、设备ID、互联网协议地址、您访问的时间和地点、路由数据包、信息发送人和接收数据（但不是信息本身），以及其他类似的特征记录。</p>
      <p class="card-cont1">2.个人信息的使用</p>
      <p class="card-cont1">• 2.1 除本隐私政策未载明或本隐私政策的更新未能首先通知您的情况下，您的个人信息将不会用于其他目的。</p>
      <p class="card-cont1">• 2.2 匿名汇总统计数据不是“绿仔管家（用户版）”所定义的个人用户信息，我们将为多种目的，包括但不限于分析和使用模式的报告等，来保存和使用此类信息。“绿仔管家（用户版）”保留以任何目的或单方面许可第三方使用和披露匿名汇总统计数据的权利。</p>
      <p class="card-cont1">3.个人信息的披露</p>
      <p class="card-cont1">3.1 除非本隐私政策载明的有限披露，我们会妥善保存您的个人信息并不会泄露客户名单。</p>
      <p class="card-cont1">3.2 您于此授权，以下情形下，我们将会向第三方披露您的个人信息而无需通过您的同意：</p>
      <p class="card-cont1">• 如果我们披露这些信息是用来识别、联系或向可能对我们的权利或财产、网站用户或者其他任何人（包括其他任何人的权利和财产）造成损害之行为提起诉讼之必要；</p>
      <p class="card-cont1">• 法律调查之必要；</p>
      <p class="card-cont1">• 此类披露是法律规定或应向我们送达的传票或其他执法部门发出的令状之必要。</p>
      <p class="card-cont1">4.安全</p>
      <p class="card-cont1">对我们来说，个人信息的安全非常重要。我们将尽合理的商业努力保障您的个人信息安全，并实施合理的商业程序限制非授权访问、使用或者披露您的个人信息。尽管采取上述措施，但是您应当知晓“绿仔管家（用户版）”不能完全避免与个人信息相关的安全危险。</p>
      <p class="card-cont1">5.</p>
      <p class="card-cont1">您应当协助我们以保护您的个人信息安全。例如，不要泄露您的个人密码。</p>
      <p class="card-cont1">6.第三方网站</p>
      <p class="card-cont1">6.1 当您点击“绿仔管家（用户版）”链接的其他网站时，您已经离开我们的网站并访问其他网站，其他网站可能会收集您的个人信息或匿名数据，因此，我们无法控制、检查或者回应此类网站和网站内容。</p>
      <p class="card-cont1">6.2 本隐私政策不适用于在您点击链接后的外部网站收集数据的行为。</p>
      <p class="card-cont1">7.对青少年个人信息的收集和使用</p>
      <p class="card-cont1">7.1 “绿仔管家（用户版）”非常重视对青少年个人信息收集和使用的安全性和保护。我们建议，任何16周岁以上的未成年人参加网上活动应事先取得家长或其法定监护人的书面同意。</p>
      <p class="card-cont1">7.2 “绿仔管家（用户版）”不会使用未成年人的个人信息，也不会向任何第三方透露可识别的信息。</p>
      <p class="card-cont1">8.本隐私政策的修订</p>
      <p class="card-cont1">8.1 本隐私政策容许调整，如果我们对使用您的个人信息方法做出任何实质性调整，我们将通过您提供的电子邮件地址，或通过网站的公告通知您。</p>
      <p class="card-cont1">8.2 我们发出的包含此类变更通知的电子邮件毫无疑问的组成上述变更通知的有效部分。如果您不希望我们改变对您个人信息的使用，您必须早于您期望停止使用我们的账户之前通知我们。您继续使用“绿仔管家（用户版）”的行为，将被视为您知晓并同意受通知中此类变更条款的约束。</p>
      <p class="card-cont1 center">©第一物业服务(北京)有限公司</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  data() {
    return {};
  },
  mounted: function() {
    document.title = "业主协议";
  }
};
</script>
    
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#content-bg {
  padding: 0 15px;
}
#content-bg .card-first {
  padding: 0 0 15px;
}
#content-bg .card {
  padding: 15px 0;
}
#content-bg .line:after {
  content: "";
  display: block;
  border-bottom: 1px solid #e0e4eb;
  transform: scaleY(0.5);
  width: 100%;
}
#content-bg .card-last {
  padding: 15px 0;
}
#content-bg .title-p1 {
  font-size: 17px;
  color: #0b1d32;
  margin-bottom: 20px;
  font-weight: 600;
}
#content-bg .card-cont1 {
  font-size: 14px;
  color: #0b1d32;
  letter-spacing: 0;
}
#content-bg .needpad {
  margin-top: 15px;
}
#content-bg .card-cont2 {
  font-size: 14px;
  color: #788596;
  letter-spacing: 0;
}
#content-bg .center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/agreement/content-owner.vue